export default [
  // Deactive CTWA for temporary
  // {
  //   path: '/whatsapp-ads',
  //   name: 'marketing',
  //   component: () => import('@/views/pages/komads/List.vue'),
  //   meta: {
  //     resource: 'Marketing',
  //     action: 'manage',
  //   },
  // },
  // {
  //   path: '/whatsapp-ads/balance-history',
  //   name: 'marketing',
  //   component: () => import('@/views/pages/komads/HistoryBalance.vue'),
  //   meta: {
  //     resource: 'Marketing',
  //     action: 'manage',
  //     navActiveLink: 'marketing',
  //   },
  // },
  {
    path: '/whitelisted-account',
    name: 'whitelisted-account',
    component: () => import('@/views/pages/komads/WhitelistedAccount.vue'),
    meta: {
      resource: 'Whitelisted Account',
      action: 'manage',
      navActiveLink: 'whitelisted-account',
    },
  },
  // Deactive CTWA for temporary
  // {
  //   path: '/categories-detail',
  //   name: 'categories-detail-komads',
  //   component: () => import('@/views/pages/komads/DetailCategory.vue'),
  //   meta: {
  //     resource: 'Marketing',
  //     action: 'manage',
  //     navActiveLink: 'marketing',
  //   },
  // },
]
